import AbstractService from 'core/abstracts/AbstractService';
import Facade from 'core/Facade';

class ProxyService extends AbstractService {

    addParamToUrl(url, paramName, paramValue) {
        return url + '&' + paramName + '=' + paramValue;
    }

    getDomains(pageSize = '5', pageIndex = '1', providerFilter = null, typeFilter = null, countryFilter = null, hostFilter = null) {

        let formattedUrl = Facade.getApiRoot() + 'bo/proxies?ps=' + pageSize + '&p=' + pageIndex;

        if (providerFilter) formattedUrl = this.addParamToUrl(formattedUrl, 'provider', providerFilter);
        if (typeFilter) formattedUrl = this.addParamToUrl(formattedUrl, 'type', typeFilter);
        if (countryFilter) formattedUrl = this.addParamToUrl(formattedUrl, 'country', countryFilter);
        if (hostFilter) formattedUrl = this.addParamToUrl(formattedUrl, 'host', hostFilter);

        return this.request({
            method: 'GET',
            url:  formattedUrl
        }).then(async (responseData) => {
            if (responseData.ok) {
                return {
                    count: responseData.headers.get('X-Total-Count'),
                    proxies: await responseData.json()
                };
            }
            throw await responseData.json();
        });
    }

    modifyDomain(proxy) {
        const formattedUrl = Facade.getApiRoot() + 'bo/proxies/' + proxy.id;
        return this.request({
            method: 'PUT',
            url:  formattedUrl,
            json: proxy
        }).then(responseData => {
            if (responseData.ok) {
                return {
                    result: responseData
                };
            }
            throw responseData;
        });
    }

    createDomain(proxy) {
        const formattedUrl = Facade.getApiRoot() + 'bo/proxies';
        return this.request({
            method: 'POST',
            url:  formattedUrl,
            json: proxy
        }).then(responseData => {
            if (responseData.ok) {
                return {
                    result: responseData
                };
            }
            throw responseData.json();
        });
    }

    deleteDomain(id) {
        return this.request({
            method: 'DELETE',
            url:  Facade.getApiRoot() + 'bo/proxies/' + id,
        }).then(responseData => {
            if (responseData.ok) {
                return {
                    result: responseData
                };
            }
            throw responseData;
        });
    }
}

export default new ProxyService();
